import React from 'react';

import {
  FilePreviewIcon,
  FilePreviewInfo,
  FilePreviewItem,
  FilePreviewName,
  FilePreviewRemove,
  FilePreviewSize,
  FilePreviewThumbnail,
  FilePreviewContainer as StyledFilePreviewContainer,
} from '../ChatSingle.styles';

const getFileType = (file) => {
  const mimeType = file.type;

  if (mimeType.startsWith('image/')) return 'image';
  if (mimeType.startsWith('video/')) return 'video';
  if (mimeType.startsWith('audio/')) return 'audio';
  return 'file';
};

const getFileIcon = (file) => {
  const mimeType = file.type;
  const extension = file.name.split('.').pop()?.toLowerCase();

  if (mimeType.startsWith('image/')) return '🖼️';
  if (mimeType.startsWith('video/')) return '🎬';
  if (mimeType.startsWith('audio/')) return '🎵';
  if (mimeType.startsWith('application/pdf')) return '📄';
  if (mimeType.includes('word') || extension === 'doc' || extension === 'docx') return '📝';
  if (mimeType.includes('sheet') || extension === 'xls' || extension === 'xlsx') return '📊';
  if (mimeType.includes('zip') || extension === 'zip' || extension === 'rar') return '📦';
  return '📎';
};

const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};

const FilePreviewContainer = ({ selectedFiles, filePreviewUrls, onRemove }) => {
  const files = Array.isArray(selectedFiles)
    ? selectedFiles
    : selectedFiles
      ? [selectedFiles]
      : [];

  if (files.length === 0) return null;

  return (
    <StyledFilePreviewContainer>
      {files.map((file, index) => {
        const previewUrl = filePreviewUrls?.[index] || filePreviewUrls;

        return (
          <FilePreviewItem key={`${file.name}-${index}`}>
            {previewUrl ? (
              <FilePreviewThumbnail src={previewUrl} alt={file.name} />
            ) : (
              <FilePreviewIcon $fileType={getFileType(file)}>
                {getFileIcon(file)}
              </FilePreviewIcon>
            )}
            <FilePreviewInfo>
              <FilePreviewName title={file.name}>{file.name}</FilePreviewName>
              <FilePreviewSize>{formatFileSize(file.size)}</FilePreviewSize>
            </FilePreviewInfo>
            <FilePreviewRemove
              onClick={() => onRemove(index)}
              aria-label={`Remove ${file.name}`}
              title="Remove file"
            />
          </FilePreviewItem>
        );
      })}
    </StyledFilePreviewContainer>
  );
};

export default FilePreviewContainer;
